// extracted by mini-css-extract-plugin
export default {"container":"ph4se_container__dBeAx","dw":"ph4se_dw__wXVy1"};